module.exports = "<div>\n\n    <router-view></router-view>\n    \n</div>"